import moment from "moment";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { CHART_MODE, CHART_TYPE } from "../components/MetricChart/metricChartUtil";
import { inferDate } from "../components/MetricChart/useMetricChartHook";
import * as R from "rambda";

export const mmOrInch = (units) => {
    if (units) {
        return "inch";
    }
    else {
        return "mm";
    }
};

export const mmOrMiles = (units) => {
    if (units) {
        return "mils/yr";
    } else {
        return "mm/yr";
    }
};

export const generateDate = timeStamp => {
    const d = new Date(timeStamp);
    const new_date = moment(d).format('DD/MM/yyyy');
    return `${new_date}`;
};

export const round = (number, digits) => {
    if (number === 0) {
        return 0;
    }
    else {
        return Math.round(number * (Math.pow(10, digits))) / Math.pow(10, digits) || "NA";
    }
};


export const getFeatureName = (name) => {
    switch (name) {
        case "DewPoint":
            return `Aqueous dew point (overhead vapors)`
        case "DeltaT":
            return `TCR vs. aq. dew point (overhead vapors)`
        case "Sulphur_O3":
            return "Residual_S03"
        case "DISS_O":
            return "Dissolved Oxygen"
        case "Water":
            return "Prod_Injectedwater/day"
        case "Liquid":
            return "Oxy-Scav_LPD"
        default:
            return name;
    }
}




export const reformatData = (array) => {
    const redefineData = [];
    array.forEach(data => {
        const pKey = Object.keys(data.result)[0];
        const childKeys = Object.keys(data.result[pKey]);
        const formatData = {
            [pKey]: {},
        };
        console.log("Reformatting data for key:", pKey, "with child keys:", childKeys);
        childKeys.forEach(key => {
            const obj = {
                [key]: {
                    unit: key === "MissingAvailability" ? { symbol: "%" } : data?.result[pKey][key]?.unit,
                    metaData: data?.result[pKey][key],
                    data: data.result[pKey][key]?._data,
                    dates: (new Array(data.result[pKey][key]?._data?.length).fill(0))
                        .map((_, i) => inferDate(data?.result[pKey][key]?.tsInfo?.start, data?.result[pKey][key]?.tsInfo?.interval, i)),
                    ...data?.result[pKey][key]?.tsInfo,
                    count: data?.result[pKey][key]?.tsInfo?._size,
                    end: data?.result[pKey][key]?.tsInfo?.end,
                    start: data?.result[pKey][key]?.tsInfo?.start,
                    interval: data?.result[pKey][key]?.tsInfo?.interval,
                    missing: data?.result[pKey][key]?.tsInfo?.missing
                        ? data?.result[pKey][key]?.tsInfo?.missing.map(e => e ? 100 : 0)
                        : new Array(data?.result[pKey][key]?.tsInfo?._size).fill(0),
                },
            };

            if (obj[key].data.length === 1 && !data?.result[pKey][key]?.tsInfo?.missing) {
                obj[key].data = new Array(data?.result[pKey][key]?.tsInfo?._size).fill(obj[key].data[0]);
            }
            formatData[pKey] = {
                ...formatData[pKey],
                ...obj,
            };
        });
        redefineData.push({ ...data, result: formatData });
    });
    return redefineData;
};

export const downloadAsExcel = async (sheets, fileName = 'download.xlsx', headingData = []) => {
    const workbook = new ExcelJS.Workbook();

    sheets.forEach(({ sheetName, data }) => {
        const worksheet = workbook.addWorksheet(sheetName);

        if (data.length > 0) {
            // Add the header
            if (headingData.length > 0) {
                headingData.forEach((row) => {
                    worksheet.addRow(row);
                });

                worksheet.columns = Object.keys(data[0]).map(key => ({ key }));
                worksheet.addRow([]);
                worksheet.addRow([]);
                worksheet.addRow(Object.keys(data[0]).map(key => key))
            }
            else {
                worksheet.columns = Object.keys(data[0]).map(key => ({ header: key, key }));
            }


            // Add the data
            data.forEach((row) => {
                worksheet.addRow(row);
            });
        }
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, fileName);
};


export const reformatAnalysisData = (analysisDataObj) => {
    const redefineDataObj = {};
    const parentKeys = Object.keys(analysisDataObj?.result);
    parentKeys.forEach(pKey => {
        const childKeys = Object.keys(analysisDataObj?.result[pKey]);
        redefineDataObj[pKey] = {};
        childKeys.forEach(key => {
            redefineDataObj[pKey][key] = {
                unit: analysisDataObj?.result[pKey][key]?.unit,
                metaData: analysisDataObj?.result[pKey][key],
                data: analysisDataObj.result[pKey][key]?._data || new Array(analysisDataObj?.result[pKey][key]?.tsInfo?._size).fill(0),
                dates: (analysisDataObj.result[pKey][key]?._data || new Array(analysisDataObj?.result[pKey][key]?.tsInfo?._size).fill(0))
                    .map((_, i) => inferDate(analysisDataObj?.result[pKey][key]?.tsInfo?.start, analysisDataObj?.result[pKey][key]?.tsInfo?.interval, i)),
                ...analysisDataObj?.result[pKey][key]?.tsInfo,
                count: analysisDataObj?.result[pKey][key]?.tsInfo?._size,
                end: analysisDataObj?.result[pKey][key]?.tsInfo?.end,
                start: analysisDataObj?.result[pKey][key]?.tsInfo?.start,
                interval: analysisDataObj?.result[pKey][key]?.tsInfo?.interval,
                missing: analysisDataObj?.result[pKey][key]?.tsInfo?.missing ? analysisDataObj?.result[pKey][key]?.tsInfo?.missing.map((e) => e ? 100 : 0) : new Array(analysisDataObj?.result[pKey][key]?.tsInfo?._size).fill(0),
            };
        });
    });
    return { result: redefineDataObj };

};


const months = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sep',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec'
};

export const formatDate = (date) => {
    if (JSON.stringify(date) !== "null") {
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const month = months[monthIndex];
        const year = date.getFullYear();
        const finalDate = `(${day} ${month} ${year})`;
        return finalDate;
    }
    else return null;
};

export const splitToArray = (id) => id.split("T");

export const getSiteType = (site, prodUnit) => {
    const isNorco = site === "SNR";
    const isNorcoWest = isNorco && prodUnit === "REFINING WEST";
    const isNorcoEast = isNorco && prodUnit === "REFINING EAST";
    const isRhienland = site === "D014 (RRN)" || site === "D015 (RRS)";
    const isSyngas = site === "A081";
    const isBonga = site === "BON";
    const isScotfordHCU = site === "C320" && (prodUnit === "HCU-1" || prodUnit === "HCU-2");
    const isScotfordADU = site === "C320" && prodUnit !== "HCU-1" && prodUnit !== "HCU-2";
    const isBukom = site === "S901";
    const isPernis = site === "N011";
    return {
        isNorco,
        isNorcoWest,
        isNorcoEast,
        isRhienland,
        isSyngas,
        isBonga,
        isScotfordHCU,
        isScotfordADU,
        isBukom,
        isPernis
    }
}

export const mapAndJoinArray = (arr) => {
    if (typeof arr[0] === 'string') {
        return arr.map((v) => "'" + v + "'").join(",");
    }
    return arr.map((v) => "'" + v.value + "'").join(",");
};


export const buildOptionsFilterStr = (arr) => {
    return arr.map(item => `'${item.value}'`).join(", ");
};


export const calculateFixedYRange = (metricData, units, fixedYRangeVariables) => {

    if (!metricData) return null;

    const meanValues = metricData
        .map((k) => k.y)
        .map((l) => l.reduce((a, b) => a + b, 0) / l.filter((obj) => obj !== null).length)
        .filter((obj) => !isNaN(obj));

    const meanMeanValues = meanValues.reduce((a, b) => a + b, 0) / meanValues.length;
    const maxValue = Math.max(
        ...metricData.map((k) => k.y).map((l) => Math.max(...l.filter((obj) => obj > 0)))
    );
    const minValue = Math.min(
        ...metricData.map((k) => k.y).map((l) => Math.min(...l.filter((obj) => obj > 0)))
    );

    const rangeThreshold = units ? 0.0125 : 0.25;

    if (
        maxValue - meanMeanValues <= rangeThreshold &&
        meanMeanValues - minValue <= rangeThreshold &&
        metricData.map((k) => k.name).some((elem) => fixedYRangeVariables.includes(elem))
    ) {
        return [meanMeanValues - rangeThreshold, meanMeanValues + rangeThreshold];
    }

    return null;
};



export const fetchFeature = (checkboxes, metricName, feature) => {
    return Object.entries(checkboxes)
        .filter(([key, value]) => value.expr === metricName)
        .map((k) => k[1][feature])
        .toString();
};

export const generateRequests = (checkboxes, id, path, requestType = "default") => {
    let body = {};
    if (path === 'SensorExpression') {
        body.subject_filter = `sensor.id ='${id}'`;
    }else{
        body.ids = [id];
    }
    let expressions_with_units = Object.entries(checkboxes)
            .filter(([key, value]) => value.enabled && value.fetch === 1)
            .map((k) => ({expr: k[1].expr, unit: k[1].expr_unit}));
    let expressions = expressions_with_units.map((e) => e.expr);
    let units = expressions_with_units.map((e) => e.unit);

    return !!expressions.length
        ? [
            {
                labelMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "name");
                },
                colorMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "color");
                },
                dashMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "dash");
                },
                variableMarkersMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "variablemarkers");
                },
                stackgroupMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "stackgroup");
                },
                yaxisMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "yaxis");
                },
                layerorderMapping: (metricName, metricId) => {
                    return fetchFeature(checkboxes, metricName, "layerorder");
                },
                type: CHART_TYPE.SCATTER,
                mode: CHART_MODE.LINE,
                showlegend: true,
                path: path,
                body: {
                        ...body,
                        expressions: expressions,
                        units: units
                    },
                
            },
        ]
        : [];
};


// Returns the first non-zero corrosion rate
export const findFirstNonZeroCorrosionRate = (corrosionData) => {
    if (!Array.isArray(corrosionData) || corrosionData?.length === 0) {
        return null; // Return null or a default value if the array is empty or undefined
    }
    if (corrosionData[0]?.toFixed(3) === "0.000") {
        return corrosionData[0]?.toFixed(3);
    }
    return corrosionData[0]?.toFixed(3);
};

// Finds the last date for a given element in the input data
export const getLastDate = (inputdata, id, element) => {
    const dates = R.path(["result", id, element, "dates"], inputdata);
    const data = R.path(["result", id, element, "data"], inputdata);

    if (dates && data) {
        const lastDate = formatDate(
            new Date(dates.filter((_, index) => data[index] > 0).at(-1))
        );
        return lastDate;
    }
};

// Finds the last value for a given element in the input data
export const getLastValue = (inputdata, id, element) => {
    const data = R.path(["result", id, element, "data"], inputdata);

    if (data) {
        const lastValue = data.filter((item) => item > 0).at(-1);
        return lastValue;
    }
};


export const getExpressions = (isRhienland, additionalMetrics = []) => {
    const MeasuredWallThicknessMetric = isRhienland
        ? "RHE_MeasuredWallThickness_UI"
        : "MeasuredWallThicknessTComp";
    const PredictedWallThicknessMetric = isRhienland
        ? "LiveModelPredictedWallThickness_RHE"
        : "LiveModelWallThickness";

    const baseExpressions = [
            MeasuredWallThicknessMetric,
            "MeasuredCorrosionRate",
            PredictedWallThicknessMetric,
            "LiveModelCorrosionRate",
        ]

    // Include additional metrics specific to the component
    return [...baseExpressions, ...additionalMetrics];
};


export const siteMapping = (site) => {
    switch (site) {
        case 'SNR':
            return 'NORCO';
        case 'A081':
            return 'PEARL-GTL';
        case 'D014 (RRN)':
            return 'RHEINLAND (RRN)';
        case 'N011':
            return 'PERNIS';
        case 'S901':
            return 'BUKOM';
        case 'C320':
            return 'SCOTFORD';
        case 'D015 (RRS)':
            return 'RHEINLAND (RRS)';
        default:
            return site;
    }
}

export const convertmmToMils = (value) => {
    const num = value * 39.37;
    return round(num, 3)
}

export const convertMilsToMm = (value) => {
    const num = value / 39.37;
    return round(num, 3)
}

export const renderTemperatureCut = (tempCut, units) => {
    if (!tempCut) return null;

    const [minCut, maxCut, unit] = tempCut.split(",");
    const formatTemperature = (min, max, isFahrenheit) => {
        const minFormatted = isFahrenheit ? round((1.8 * parseFloat(min)) + 32, 2) : round(parseFloat(min), 2);
        const maxFormatted = isFahrenheit ? round((1.8 * parseFloat(max)) + 32, 2) : round(parseFloat(max), 2);
        return `${min === "IBP" ? "IBP" : minFormatted} - ${max === "FBP" ? "FBP" : maxFormatted}`;
    };

    const formatTemperatureAlt = (min, max, isFahrenheit) => {
        const minFormatted = isFahrenheit ? round(parseFloat(min), 2) : round((parseFloat(min) - 32) * (5 / 9), 2);
        const maxFormatted = isFahrenheit ? round(parseFloat(max), 2) : round((parseFloat(max) - 32) * (5 / 9), 2);
        return `${min === "IBP" ? "IBP" : minFormatted} - ${max === "FBP" ? "FBP" : maxFormatted}`;
    };

    if (unit === "C") {
        return (
            <span>
                {units
                    ? `${formatTemperature(minCut, maxCut, true)} °F`
                    : `${formatTemperature(minCut, maxCut, false)} °C`}
            </span>
        );
    } else {
        return (
            <span>
                {units
                    ? `${formatTemperatureAlt(minCut, maxCut, true)} °F`
                    : `${formatTemperatureAlt(minCut, maxCut, false)} °C`}
            </span>
        );
    }
};


export const valueToColor = (y) => {
    const config = {
        true: "#C9EC9A",
        false: "#FFDAAE",
    };
    return config[y] || "rgba(55,128,191,0.6)";

}

export const getUniqueValues = (options, filterData) => {

    if (options && options.length > 0) {
        const filterOption = options
            .filter(obj => obj[filterData])
            .map(o => o[filterData])
            .filter((value, index, self) => self.indexOf(value) === index)
            .map((o) => ({ label: o, value: o }));
        return filterOption;
    } else {
        return [];
    }
}

export const getAllOptions = (filterData, required_hierarchy="") => {
    let siteOptions = {}
    let productionUnitOptions = {}
    let unitOptions = {}
    let equipmentOptions = {}
    let cmlOptions = {}
    if (filterData && filterData.length > 0) {
        for (let data of filterData) {
            siteOptions[data.site] = { label: data.siteName, value: data.site };
            productionUnitOptions[data.productionUnit] = { label: data.productionUnitName, value: data.productionUnit };
            unitOptions[data.unit] = { label: data.unitName, value: data.unit };
            equipmentOptions[data.equipment] = { label: data.equipmentName, value: data.equipment };
            cmlOptions[data.conditionMonitoringLocation] = { label: data.conditionMonitoringLocationName, value: data.conditionMonitoringLocation };
        }
    }

    switch(required_hierarchy){
        case "site":
            return { siteOptions: Object.values(siteOptions) };
        case "productionUnit":
            return { productionUnitOptions: Object.values(productionUnitOptions) };
        case "unit":
            return { unitOptions: Object.values(unitOptions) };
        case "equipment":
            return { equipmentOptions: Object.values(equipmentOptions) };
        case "cml":
            return { cmlOptions: Object.values(cmlOptions) };
        default:
            return {
                siteOptions: Object.values(siteOptions),
                productionUnitOptions: Object.values(productionUnitOptions),
                unitOptions: Object.values(unitOptions),
                equipmentOptions: Object.values(equipmentOptions),
                cmlOptions: Object.values(cmlOptions),
            }
    }
}


export const getNextAvailableFilter = (type, filterFormValues) => {
    const filterOrder = ['site', 'productionUnit', 'unit', 'equipment', 'cml',];
    const currentFilterIndex = filterOrder.indexOf(type);

    // Start from the current filter and go upwards
    for (let i = currentFilterIndex - 1; i >= 0; i--) {
        const filter = filterOrder[i];

        // If the filter has selected values, return it
        if (filterFormValues[filter].length > 0) {
            return filter;
        }
    }

    // If no available filter is found, return null
    return null;
};

export const isAnyFilterSelected = (filterFormValues) => {
    return Object.values(filterFormValues).some(filter => filter.length > 0);
};


export function getMinMaxFromGraphData(graphdata) {
    const allValueArrays = graphdata?.map((data) => data?.y);
    const allValues = (allValueArrays || [])
        .flat()
        .filter(v => v !== null);
    const min = allValues.length > 0 ? Math.min(...allValues) : 0;
    const max = allValues.length > 0 ? Math.max(...allValues) : 0;
    return { min, max };
}